import React, { useState } from "react";
import { ContentCopyOutlined as ContentCopy, DeleteOutlined as Delete } from '@mui/icons-material';
import { useNodeStorage } from "../../../stores/useNodeStorage";

export const NodeWrapper = ({ id, selected, children, width = "300px", color = "#cbd5e1" }) => {
  const [isHovered, setIsHovered] = useState(false);
  const storageItems = useNodeStorage();

  // Border always 2px — no layout shift on hover
  const border = selected
    ? `2px solid #7c3aed`
    : `2px solid ${color}`;

  // Hover: glow difuminado del color del nodo
  const boxShadow = selected
    ? `0 0 0 3px rgba(124, 58, 237, 0.25), 0 4px 12px rgba(0,0,0,0.1)`
    : isHovered
      ? `0 0 14px 4px ${color}55, 0 4px 12px rgba(0,0,0,0.08)`
      : `0 2px 6px rgba(0,0,0,0.06)`;

  return (
    <div
      className="input-node-custom"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: "relative",
        minWidth: "220px",
        maxWidth: "320px",
        width,
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        border,
        boxShadow,
        transition: "box-shadow 0.2s ease-in-out, border-color 0.15s ease-in-out"
      }}
    >
      {selected && (
        <div style={{
          position: "absolute",
          top: "-45px",
          right: "0",
          backgroundColor: "#ffffff",
          padding: "6px 8px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
          display: "flex",
          gap: "8px",
          border: "1px solid #e2e8f0",
          zIndex: 10
        }}>
          <ContentCopy
            onClick={e => { e.stopPropagation(); storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
            style={{ width: "18px", height: "18px", color: "#64748b", cursor: "pointer" }}
          />
          <Delete
            onClick={e => { e.stopPropagation(); storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
            style={{ width: "18px", height: "18px", color: "#ef4444", cursor: "pointer" }}
          />
        </div>
      )}
      {children}
    </div>
  );
};
